module.exports = __webpack_public_path__ + "static/media/subscribeGuide4_Jap.479f2443.png";